import React, { useEffect, useState } from 'react';
import { Select as CommonSelect } from '@blueprintnyc/bpnyc-common-admin';

const Select = props => {
	const { data, value, onChange, form, placeholder, type, style } = props;
	const [options, setOptions] = useState([]);
	const [selectedArr, setSelectedArr] = useState([]);

	useEffect(() => {
		if (data && data.length) {
			if (type === 'photobooth') {
				const opts = data.map(a => ({
					id: a.id,
					name: a.camName,
				}));
				setOptions(opts);
			} else setOptions(data);
		}
		return () => {
			setOptions([]);
		};
	}, [data]);

	useEffect(() => {
		if (value && value.length) {
			if (Array.isArray(value)) {
				setSelectedArr(value);
			} else {
				const selectedObj = data.find(obj => `${obj.name}` === value);
				if (selectedObj && selectedObj.id) setSelectedArr([selectedObj.id]);
			}
		}

		return () => {
			setSelectedArr([]);
		};
	}, [value, data]);

	const handleOnChange = selected => {
		if (onChange) onChange(selected);
	};

	const selectProps = {
		options,
		placeholder,
		selected: selectedArr,
		onChange: handleOnChange,
		style: style,
		className: form ? 'form-styles' : '',
	};

	return <CommonSelect {...selectProps} />;
};

export default Select;
